import { Box, Button, Text } from '@betty/moonlight';
import { memo, useCallback, useMemo } from 'react';
import { Pressable } from 'react-native';
import { Trans } from '@betty/i18n';
import {
  BottomSheet,
  StackNavigationProp,
  useNavigation,
} from '@betty/navigation';

function CloseAccount() {
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();
  const onClose = useCallback(
    () =>
      BottomSheet.open({
        namespace: 'account',
        type: 'CloseAccount',
        titleNS: 'account',
        titleKey: 'myProfileCloseAccountTitle',
      }),
    [],
  );

  const onCustomerSupportPress = useCallback(() => {
    navigation.navigate('MiscScreen', { path: '/contact' });
  }, [navigation]);

  const transComponents = useMemo(
    () => ({
      customerSupportLink: (
        <Text variant="body-m" color="darkSurfaceAccentSolid" />
      ),
    }),
    [],
  );

  return (
    <Box paddingTop="space-800" gap="space-600">
      <Pressable onPress={onCustomerSupportPress}>
        <Text variant="body-m" color="darkSurfacePrimary" textAlign="center">
          <Trans
            ns="account"
            i18nKey="myProfileSupportText"
            components={transComponents}
          />
        </Text>
      </Pressable>
      <Button
        variant="secondary"
        locNS="account"
        locKey="myProfileCloseAccountCta"
        onPress={onClose}
        marginHorizontal="auto"
      />
    </Box>
  );
}

export default memo(CloseAccount);
